import React, { useMemo } from 'react';

export default function IDEnquiryConfirmStep({
  idEnquiryFirstName,
  idEnquiryLastName,
  idEnquiryPhone,
  idEnquiryEmail,
  idEnquiryBuilding,
  idEnquiryArea,
  idEnquiryCity,
  idEnquiryStore,
  idEnquiryComments,
}) {
  const enquiryNumber = useMemo(
    () => 'ENQ-' + Math.floor(Math.random() * 900000 + 100000),
    []
  );

  const fullName = [idEnquiryFirstName, idEnquiryLastName].filter(Boolean).join(' ');
  const address = [idEnquiryBuilding, idEnquiryCity?.value, idEnquiryArea?.value]
    .filter(Boolean)
    .join(', ');

  return (
    <div className="step-5 confirmation-card">
      <div className="confirmation-card-body">
        <div className="confirmation-message">
          <h4>Enquiry Submitted!</h4>
          <p>
            Thank you for reaching out. Our Interior Design team will contact{' '}
            <strong>{idEnquiryEmail}</strong> shortly.
          </p>
        </div>

        <div className="confirmation-details">
          <div className="service-info">
            <div>
              <h3 className="strongtitle">Interior Design Service</h3>
              <p>
                Our specialists will review your enquiry and get back to you to discuss your
                interior design needs.
              </p>
            </div>
          </div>

          <ul className="booking-more-info">
            <li>
              <span>Enquiry Number</span>
              <h4>{enquiryNumber}</h4>
            </li>
            <li>
              <span>Name</span>
              <h4>{fullName || '—'}</h4>
            </li>
            <li>
              <span>Phone</span>
              <h4>+971 {idEnquiryPhone}</h4>
            </li>
            <li>
              <span>Email</span>
              <h4>{idEnquiryEmail}</h4>
            </li>
            <li>
              <span>Address</span>
              <h4>{address || '—'}</h4>
            </li>
            <li>
              <span>Preferred Store</span>
              <h4>{idEnquiryStore || '—'}</h4>
            </li>
            {idEnquiryComments && (
              <li style={{ gridColumn: '1 / -1' }}>
                <span>Comments</span>
                <h4>{idEnquiryComments}</h4>
              </li>
            )}
          </ul>
        </div>

        <div className="confirmation-footer">
          <button
            className="cta-button"
            onClick={() => (window.location.href = '/app/index.html')}
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </div>
  );
}
